module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0103.jpg?v=c8246e7c";